var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-y-chart',{attrs:{"data-config":_vm.dataConfig,"unit-prop":_vm.unitProp,"chart-type":"line","stack-type":0,"download-name":_vm.downloadName,"chart-min-height":_vm.chartMinHeight,"chart-height":_vm.chartHeight,"selected-change-with-data-changed":"","need-resize":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5405c250","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Data/ChartWrapper/DefaultChart.vue
// module id = null
// module chunks = 